import {
  Avatar,
  Divider,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  compressImageFile,
  customValidation,
  EPhone,
  formatPhoneNumber,
  Method,
  updateMainHeader,
  validations,
} from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";
import { WSIcons } from "../../commonFunctions/iIcons";
import SwipeableDrawerForm from "../../Components/DrawyerForm/DrawyerForm";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import {
  HeaderList,
  IHeaderListActions,
} from "../../Components/Header/HeaderList";
import WSPhone from "../../Components/Phone/WSPhone";
import WSRadioField from "../../Components/Radio/WSRadio";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import { WSHeaderCard } from "../../Components/View/HeaderCard";
import clientConfig from "../../Config/clientConfig.json";
import config from "../../Config/config.json";
import { storeDataComponent } from "../../StateManagement/actions";
import AddMemberDrawyer from "./Drawyers/AddMemberDrawyer";
import WSButton from "../../Components/Button/WSButton";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

const CustomerProfileCreate: React.FC<any> = React.memo((props) => {
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const [formComponent, setFormComponent] = useState<any>();
  const { register, handleSubmit, control, setValue, reset } = useForm();
  const navigate = useNavigate();
  const params = useParams();
  const [imageUrl, setImageUrl] = useState<any>([]);
  const [customerData, setCustomerData] = useState<any>(null);
  const [memberData, setMemberData] = useState<Array<any>>([]);
  const [userData, setUserData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const id = params?.id;
  const customerUserId: any = params?.userId || params?.id;
  const [isMainProfileCreated, setIsMainProfileCreated] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [open, setOpen] = React.useState(false);

  useEffect(
    () => () => {
      reset();
    },
    []
  );

    useEffect(() => {
      updateMainHeader("Customer");
    });
  
    breadCrumbsStore.updateBreadCrumbs([
      { "Customer List": "/customer/list" },
      { [!id ? "Add Customer " : "Update Customer "]: "/customer/profile/add/:userId" },
    ]);
  

  useEffect(() => {
    /**
     * Method to get the user record by id for edit purpose
     * @param id
     */

    async function getUserById(): Promise<void> {
      try {
        const response: any = await http.get(`Auth/${customerUserId}`);
        if (response) {
          setUserData(response);
          for (const field in response) {
            if (field === "phoneNumber") {
              setValue(
                field,
                formatPhoneNumber((response as any)[field], EPhone.AddHyphen)
              );
            } else {
              setValue(field, (response as any)[field]);
            }
          }
          setValue("customerName", response?.name);
        }
      } catch (error) {
        showMessage("Error fetching user:", "error");
      }
    }
    if (customerUserId) {
      getUserById();
    }
  }, [customerUserId]);
  useEffect(() => {
    /**
     * Method to get the user record by id for edit purpose
     * @param id
     */
    async function getCustomerAndMemberById(id: any): Promise<void> {
      try {
        const response: any = await http.get(
          `CustomerProfile/Group?groupId=${id}`
        );

        if (response && response.data) {
          const masterCustomer: any = response.data?.filter(
            (item: any) => item.isMaster === true
          );
          if (masterCustomer.length > 0) {
            setIsMainProfileCreated(true);
            for (const field in masterCustomer[0]) {
              if (field === "phoneNumber") {
                setValue(
                  field,
                  formatPhoneNumber(
                    (masterCustomer[0] as any)[field],
                    EPhone.AddHyphen
                  )
                );
              } else if (field === "profileImageUrl") {
                setImageUrl(
                  `${config.imgUrl}${masterCustomer[0][field]?.replace(
                    "UploadedImages/",
                    ""
                  )}`
                );
              } else {
                setValue(field, (masterCustomer[0] as any)[field]);
              }
            }
          }
          setCustomerData(masterCustomer?.length > 0 ? masterCustomer[0] : {});

          const memberCustomer: any = response.data?.filter(
            (item: any) => item.isMaster === false
          );

          setMemberData(memberCustomer);
        }
        //const memebersResponse: any = await http.get(`CustomerProfile/User/${id}`)
      } catch (error) {
        
        showMessage("Error fetching customer:", "error");
      }
    }
    if (id) {
      getCustomerAndMemberById(id);
    }
  }, [id, isUpdated]);
  const handleAddMemberClick = () => {
    setIsNew(true);
    const form: any = (
      <AddMemberDrawyer
        id={id}
        control={control}
        onSubmit={handleMemeberData}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => {
          resetMemberData();
          setOpen(false);
        }}
      />
    );
    setFormComponent(form);
    setTimeout(() => {
      setOpen(true);
    }, 10);
  };
  const handleEditMember = (e: any, row: any) => {
    setIsNew(false);
    const formNew: any = (
      <AddMemberDrawyer
        id={id}
        control={control}
        onSubmit={handleMemeberData}
        register={register}
        memberId={row.id}
        reset={reset}
        memberdata={row}
        setValue={setValue}
        onCancel={() => {
          resetMemberData();
          setOpen(false);
          setFormComponent(null);
        }}
      />
    );
    setFormComponent(formNew);
    setTimeout(() => {
      setOpen(true);
    }, 10);
  };

  const handleCancelClick = () => {
    navigate("/customer/list");
  };
  const handleUploadChange = async (uploadedFile: any) => {
    try {
      let newFile: any = await compressImageFile(uploadedFile);
      setSelectedFile(newFile);
    } catch (error) {
      showMessage("Error converting file to base64:", "error");
    }
  };
  const resetMemberData = () => {
    setValue("profileImageMember", null);
    setValue("phoneNumberMember", "");
    setValue("customerNameMember", "");
    setValue("emailMember", "");
    setValue("ageMember", "");
    setValue("bloodGroupMember", "");
    setValue("genderMember", "Male");
    setValue("addressLine1Member", "");
    setValue("addressLine2Member", "");
    setValue("stateMember", "");
    setValue("cityMember", "");
    setValue("pincodeMember", "");
    setValue("weightMember", "");
    setValue("heightMember", "");
  };

  /**
   * Method for Add/Update the data
   * @param data
   */
  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const request: any = await setRequest(data);
      if (id) {
        const response: any = await callAPI(
          `CustomerProfile/${customerData?.id}`,
          Method.PUTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          if (response.success) {
            setIsUpdated(true);
          }
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );

          response.success === true && navigate("/customer/list");
        }
      } else {
        const response: any = await callAPI(
          "CustomerProfile",
          Method.POSTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          response.success === true && navigate("/customer/list");
          setIsMainProfileCreated(true);
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
    }
  };

  const setRequest = async (data: any) => {
    try {
      
      const formData = new FormData();
      if (selectedFile) {
        formData.append("profileImage", selectedFile!);
      }
      const isMaster: any = true;
      formData.append("userId", customerUserId || id);
      formData.append(
        "phoneNumber",
        formatPhoneNumber(data?.phoneNumber, EPhone.RemoveHyphen)
      );
      formData.append("customerName", data.customerName);
      formData.append("email", data?.email);
      formData.append("groupId", customerUserId);
      formData.append("age", data?.age);
      formData.append("bloodGroup", data?.bloodGroup);
      formData.append("gender", data.gender);
      formData.append("addressLine1", data.addressLine1);
      formData.append("addressLine2", data?.addressLine2);
      formData.append("state", data.state);
      formData.append("city", data.city);
      formData.append("pincode", data.pincode);
      formData.append("weight", data?.weight);
      formData.append("height", data?.height);
      formData.append("isMaster", isMaster);
      return formData;
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  const setRequestMember = async (data: any) => {
    try {
      const formData = new FormData();
      if (data?.profileImageMember) {
        formData.append("profileImage", data?.profileImageMember!);
      }
      const isMaster: any = false;
      formData.append("userId", customerUserId || id);
      formData.append(
        "phoneNumber",
        formatPhoneNumber(data?.phoneNumberMember, EPhone.RemoveHyphen)
      );
      formData.append("customerName", data.customerNameMember);
      formData.append("email", data?.emailMember);
      formData.append("groupId", customerUserId);
      formData.append("age", data?.ageMember);
      formData.append("bloodGroup", data?.bloodGroupMember);
      formData.append("gender", data.genderMember);
      formData.append("addressLine1", data.addressLine1Member);
      formData.append("addressLine2", data?.addressLine2Member);
      formData.append("state", data.stateMember);
      formData.append("city", data.cityMember);
      formData.append("pincode", data.pincodeMember);
      formData.append("weight", data?.weightMember);
      formData.append("height", data?.heightMember);
      formData.append("isMaster", isMaster);
      return formData;
    } catch (e: any) {
      showMessage(e.error);
    }
  };
 

  const handleMemeberData = async (data: any) => {
    try {
      setLoading(true);
      dispatch(storeDataComponent("memberSubmit", { loading: true }));
      // dispatch(storeDataComponent('isSavedSuccess', { isSaved: false }));
      const request: any = await setRequestMember(data);
      if (id && data?.memberId) {
        const response: any = await callAPI(
          `CustomerProfile/${data?.memberId}`,
          Method.PUTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          dispatch(storeDataComponent("isSavedSuccess", { isSaved: true }));
          // response.success === true && navigate("/contact/customer/list");
          if (response.success) {
            setIsUpdated(true);
          }
          await getMembers();
        }
      } else {
        const response: any = await callAPI(
          "CustomerProfile",
          Method.POSTFORMDATA,
          null,
          null,
          request
        );
        if (response) {
          showMessage(
            response?.message,
            response.success === true ? "success" : "error"
          );
          // response.success === true && navigate("/contact/customer/list");
          setIsMainProfileCreated(true);
          //  dispatch(storeDataComponent('isSavedSuccess', { isSaved: true }));

          await getMembers();
        }
      }
    } catch (e: any) {
      showMessage(e.error);
    } finally {
      setLoading(false);
      dispatch(storeDataComponent("memberSubmit", { loading: false }));
    }
  };
  async function getMembers() {
    try {
      const response: any = await http.get(
        `CustomerProfile/Group?groupId=${customerUserId}`
      );
      if (response) {
        const memeberDataNew: Array<any> = response?.data || [];
        const newData: any = memeberDataNew.filter(
          (item: any) => item?.customerName !== item?.user?.name
        );
        setMemberData(newData);
      }
    } catch (e) {}
  }
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
                minHeight: "100%",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Basic Information{" "}
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    maxLength={2}
                    control={control}
                    type={TextType.AllowOnlyNumber}
                    id="customerName"
                    name="customerName"
                    rules={{ required: true }}
                    disabled
                    label="Name*"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="email"
                    {...register("email")}
                    name="email"
                    rules={customValidation(true, validations.email)}
                    label="Email *"
                    //disabled
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSPhone
                    label="Phone"
                    rules={{ required: true }}
                    control={control}
                    id="phoneNumber"
                    {...register("phoneNumber")}
                    name="phoneNumber"
                    disabled
                  ></WSPhone>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    maxLength={2}
                    control={control}
                    type={TextType.AllowOnlyNumber}
                    id="age"
                    name="age"
                    rules={{ required: false }}
                    label="Age *"
                  ></WSTextField>
                </Grid>

                <Grid item sm={6} xs={12}>
                  <WSRadioField
                    defaultValue={"Male"}
                    control={control}
                    label="Gender"
                    rules={{ required: false }}
                    id="gender"
                    name="gender"
                    options={clientConfig.genderConfig.staticOptionData}
                  ></WSRadioField>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Address Information
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="addressLine1"
                    name="addressLine1"
                    rules={{ required: true }}
                    label="Address Line1 *"
                  ></WSTextField>
                </Grid>
                <Grid item xs={12}>
                  <WSTextField
                    control={control}
                    id="addressLine2"
                    name="addressLine2"
                    rules={{ required: false }}
                    label="Address Line2 "
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="state"
                    name="state"
                    rules={{ required: true }}
                    label="State *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="city"
                    name="city"
                    rules={{ required: true }}
                    label="City *"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    control={control}
                    id="pincode"
                    name="pincode"
                    rules={{ required: true }}
                    label="Pincode *"
                    maxLength={6}
                  ></WSTextField>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Additional Information
                  </Typography>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    maxLength={2}
                    control={control}
                    type={TextType.Number}
                    id="height"
                    name="height"
                    rules={{ required: false }}
                    label="Height"
                  ></WSTextField>
                </Grid>
                <Grid item sm={6} xs={12}>
                  <WSTextField
                    maxLength={2}
                    control={control}
                    type={TextType.Number}
                    id="weight"
                    name="weight"
                    rules={{ required: false }}
                    label="Weight"
                  ></WSTextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <WSSelectField
                    rules={{ required: true }}
                    id="bloodGroup"
                    control={control}
                    options={clientConfig.bloodGroup.staticOptionData}
                    label="Blood Group"
                    name="bloodGroup"
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                paddingLeft: 20,
                paddingRight: 20,
                marginTop: 0,
                paddingBottom: 25,
                borderRadius: "8px",
              }}
            >
              <Grid container spacing={2} mt={0}>
                <Grid item sm={12} xs={12}>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    Profile
                  </Typography>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <WSImageUpload
                        control={control}
                        id="profileImage"
                        name="profileImage"
                        label="Profile Image"
                        rules={{ required: false }}
                        onChange={handleUploadChange}
                        imgUrl={imageUrl}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {memberData && (
                  <Grid item sm={8} xs={12}>
                    <Grid item container spacing={1} alignItems="center">
                      {memberData.length > 0 &&
                        memberData.map((item: any) => (
                          <>
                            <Grid item>
                              <Tooltip title={item?.customerName}>
                                <Avatar
                                  src={`${
                                    config.imgUrl
                                  }${item?.profileImageUrl?.replace(
                                    "UploadedImages/",
                                    ""
                                  )}`}
                                  alt="preview"
                                  sx={{
                                    width: 25,
                                    height: 25,
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => handleEditMember(e, item)}
                                />
                              </Tooltip>
                            </Grid>
                          </>
                        ))}
                      {isMainProfileCreated && (
                        <Grid item>
                          <Tooltip title="Add New Member">
                            <IconButton onClick={handleAddMemberClick}>
                              <WSIcons.AddIcon />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            spacing={2} // 16 px gap (2 × theme.spacing unit)
            sx={{ mt: 2 }}
          >
            <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>

            <Grid item>
              <WSButton
                id="submit"
                type="submit"
                label="Save"
                size="medium"
                onClick={handleSubmit(onSubmit)}
                variant="outlined"
                color="primary"
                loading={loading}
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#FFFFFF",
                  backgroundColor: "#098963",
                  "&:hover": {
                    backgroundColor: "#066e4f",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
      {formComponent && (
        <SwipeableDrawerForm
          anchor="right"
          title={"Add Member"}
          openForm={open}
          formComponent={<div>{formComponent}</div>}
          onClose={() => {
            setOpen(false);
            setFormComponent(null);
          }}
        />
      )}
      {/* <Grid item container spacing={2} style={{ marginTop: 10 }}>
                <Grid item sm={12} xs={12}>
                    {isMainProfileCreated && <CustomerProfilesForm />}
                </Grid>
            </Grid> */}
    </>
  );
});

export default CustomerProfileCreate;
